import { useState, useEffect } from 'react'

export const useFetchAllCashRegisters = ({ marvarApi, dispatch, onLogout, user }) => {

    const _defaultParams = {
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashRegisters, setDataCashRegisters ] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashRegisters([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: 1, // CAJA ADMINISTRATIVA
                currency_type: String(paramsToSearch.currency_type),
                idusuario: user.uid,
            }
            const response = await marvarApi.post(`/caja/assigned-cashiers`, _body)
            console.log('[useFetchData][useFetchAllCashRegisters] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.currency_type !== '') {
            setLoadingFetchCashRegisters(true)
            fetchData()
                .then((resp) => {
                    setDataCashRegisters(resp.rows)
                    setLoadingFetchCashRegisters(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCashRegisters(false)
                })
        }
    }, [execute])

    return { dataCashRegisters, loadingFetchCashRegisters, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchOperationsByUser = ({ marvarApi, dispatch, onLogout, user }) => {

    const [ dataOperations, setDataOperations ] = useState([])

    const [ loadingFetchOperations, setLoadingFetchOperations ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataOperations([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cashier-operations/operations-by-user/${user.uid}`)
            console.log('[useFetchData][useFetchOperationsByUser] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchOperations(true)
        fetchData()
            .then((resp) => {
                setDataOperations(resp.rows)
                setLoadingFetchOperations(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchOperations(false)
            })
    }, [execute])

    return { dataOperations, loadingFetchOperations, executeFetch, resetFetch }
}

export const useFetchSpecificOperation = ({marvarApi, dispatch, onLogout, Forms}) => {

    const { FormScreen } = Forms
    const { setFormState } = FormScreen

    const _defaultParams = {
        idoperacion: ''
    }
    
    const [ loadingFetchSpecificOperation, setLoadingFetchSpecificOperation ] = useState(false)

    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())
        try {
            
            const response = await marvarApi.get(`/cashier-operations/fetch-specific-operation/${paramsToSearch.idoperacion}`)
            console.log('[useFetchData][useFetchSpecificOperation] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(paramsToSearch.idoperacion > 0 ){
            setLoadingFetchSpecificOperation(true)
            fetchData()
                .then((resp) => {
                    
                    // Setea en el estado del formulario los datos del registro
                    const { rows } = resp
                    setFormState((prevState) => ({
                        ...prevState,
                        idoperacion: rows[0].idoperacion || '',
                        idcaja: rows[0].idcaja || '',
                        // idusuario: rows[0].idusuario || '', // se obtiene de la sesión
                        currency_type: rows[0].currency_type || '',
                        fecha_operacion: rows[0].fecha_operacion || ''
                    }))
                    setLoadingFetchSpecificOperation(false)

                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchSpecificOperation(false)
                })
        }
    }, [execute])

    return { loadingFetchSpecificOperation, setParamsToSearch, executeFetch }

}